import React, { useState, useEffect, useContext } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "../../../assets/css/gcadmin/adminsidebar/AdminSidebar.css";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";


const Icons = {
  Dashboard: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/>
      <rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>
    </svg>
  ),
  Books: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/>
    </svg>
  ),
  Library: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2v20M2 7l10-5 10 5M2 17l10 5 10-5M2 12l10 5 10-5"/>
    </svg>
  ),
  Issued: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 100-.49"/>
    </svg>
  ),
  Users: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
    </svg>
  ),
  Reservations: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2"/>
      <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
      <line x1="3" y1="10" x2="21" y2="10"/><line x1="8" y1="14" x2="16" y2="14"/>
    </svg>
  ),
  Notes: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="12" y2="17"/>
    </svg>
  ),
  Disputes: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  ),
  FaQ: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  ),

  Review: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  ),
  Reports: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
    </svg>
  ),
  Notification: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 01-3.46 0"/>
    </svg>
  ),
  Settings: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
    </svg>
  ),
  Logout: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
      <polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
  ChevronLeft: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  ),
  ChevronRight: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  ),
  Menu: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  ),
};

const NAV_ITEMS = [
  { label: "Dashboard",    icon: <Icons.Dashboard />,    path: "/admin/dashboard" },
  { label: "Manage Users", icon: <Icons.Users />,        path: "/admin/manage-users" },
  { label: "Manage Books", icon: <Icons.Books />,        path: "/admin/manage-books" },
  { label: "Manage eBooks",icon: <Icons.Library />,      path: "/admin/digital-lib" },
  { label: "Reservations", icon: <Icons.Reservations />, path: "/admin/reservations" },
  { label: "Issued Books", icon: <Icons.Issued />,       path: "/admin/issued-books" },
  { label: "Manage Blogs", icon: <Icons.Notes />,        path: "/admin/blogs" },
  { label: "Disputes",     icon: <Icons.Disputes />,     path: "/admin/disputes" },
  {label: "FAQS",           icon: <Icons.FaQ/>,         path: "/admin/FAQManagement" },
  { label: "Reviews",      icon: <Icons.Review />,       path: "/admin/reviews" },
  { label: "Notifications",icon: <Icons.Notification />, path: "/admin/notifications" },
  { label: "Settings",     icon: <Icons.Settings />,     path: "/admin/settings" },
];

const AdminSidebar = ({ onCollapsedChange }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setAuthToken, setLoggedInUser } = useContext(AppContext);

  const [collapsed,  setCollapsed]  = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);
  useEffect(() => {
    const fn = (e) => { if (e.key === "Escape") setMobileOpen(false); };
    window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, []);

  const handleToggle = () => {
    const next = !collapsed;
    setCollapsed(next);
    if (onCollapsedChange) onCollapsedChange(next);
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Logout?",
      text: "Are you sure you want to logout from Admin Panel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d63031",
      cancelButtonColor: "#1a5f7a",
    }).then((result) => {
      if (result.isConfirmed) {
        // Sab kuch clear karo
        localStorage.removeItem("authToken");
        localStorage.removeItem("userType");
        localStorage.removeItem("Admin");
        localStorage.removeItem("AdminEmail");
        localStorage.removeItem("AdminPassword");

        // Context bhi reset karo
        if (setAuthToken)    setAuthToken(null);
        if (setLoggedInUser) setLoggedInUser(null);

        navigate("/");
      }
    });
  };

  return (
    <>
      {/* Mobile hamburger */}
      <button
        className="gcAdmin-sb__hamburger d-lg-none"
        onClick={() => setMobileOpen(p => !p)}
        aria-label="Open menu"
      >
        <Icons.Menu />
      </button>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="gcAdmin-sb__overlay" onClick={() => setMobileOpen(false)} />
      )}

      <aside className={[
        "gcAdmin-sb",
        collapsed  ? "gcAdmin-sb--collapsed"   : "",
        mobileOpen ? "gcAdmin-sb--mobile-open" : "",
      ].filter(Boolean).join(" ")}>

        {/* ── Brand / Toggle row ── */}
        <div className="gcAdmin-sb__brand">
          <span className="gcAdmin-sb__brand-text">Admin Panel</span>
          <button
            className="gcAdmin-sb__toggle d-none d-lg-flex"
            onClick={handleToggle}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {collapsed ? <Icons.ChevronRight /> : <Icons.ChevronLeft />}
          </button>
        </div>

        {/* ── Nav ── */}
        <nav className="gcAdmin-sb__nav">
          <ul className="gcAdmin-sb__list">
            {NAV_ITEMS.map((item, i) => {
              const active =
                location.pathname === item.path ||
                location.pathname.startsWith(item.path + "/");
              return (
                <li key={item.path} className="gcAdmin-sb__item" style={{ animationDelay: `${i * 0.04}s` }}>
                  <NavLink
                    to={item.path}
                    className={`gcAdmin-sb__link ${active ? "gcAdmin-sb__link--active" : ""}`}
                    title={collapsed ? item.label : ""}
                  >
                    <span className="gcAdmin-sb__icon">{item.icon}</span>
                    <span className="gcAdmin-sb__label">{item.label}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* ── Footer / Logout ── */}
        <div className="gcAdmin-sb__footer">
          <button
            className="gcAdmin-sb__link gcAdmin-sb__link--logout"
            onClick={handleLogout}
            title={collapsed ? "Logout" : ""}
          >
            <span className="gcAdmin-sb__icon"><Icons.Logout /></span>
            <span className="gcAdmin-sb__label">Logout</span>
          </button>
        </div>

      </aside>
    </>
  );
};

export default AdminSidebar;